
import React from 'react';

export const CultureSection: React.FC = () => {
  const values = [
    {
      title: 'Innovation First',
      description: 'We embrace cutting-edge technologies and creative solutions to drive business transformation.',
      image: 'https://public.readdy.ai/ai/img_res/30e1854d7ebd6f44a7e8f54276179799.jpg'
    },
    {
      title: 'Excellence in Execution',
      description: 'We deliver exceptional results through meticulous planning, strategic thinking, and flawless execution.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20team%20executing%20strategic%20plans%20with%20precision%2C%20showing%20charts%2C%20analytics%2C%20and%20successful%20project%20completion%20in%20a%20modern%20office%20environment%20representing%20excellence%20and%20achievement&width=600&height=400&seq=culture-excellence&orientation=landscape'
    },
    {
      title: 'Collaborative Growth',
      description: 'We believe in the power of teamwork and shared success across all our authority domains.',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20business%20professionals%20collaborating%20effectively%20in%20a%20modern%20workspace%2C%20sharing%20ideas%2C%20working%20together%20on%20projects%2C%20representing%20teamwork%20and%20collaborative%20business%20culture&width=600&height=400&seq=culture-collaboration&orientation=landscape'
    }
  ];

  return (
    <section id="culture" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Culture & Values</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            At Business Development Authority, we foster a culture of innovation, excellence, and collaboration. Our values guide everything we do and shape the environment where our team thrives.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {values.map((value, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url('${value.image}')` }}></div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Life at BDA</h3>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 text-white rounded-full mr-4 mt-1">
                  <i className="ri-lightbulb-line"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Continuous Learning</h4>
                  <p className="text-gray-600">Access to industry conferences, training programs, and mentorship opportunities to accelerate your professional growth.</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 text-white rounded-full mr-4 mt-1">
                  <i className="ri-global-line"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Global Impact</h4>
                  <p className="text-gray-600">Work on projects that span multiple industries and geographic regions, making a real difference in business development.</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 text-white rounded-full mr-4 mt-1">
                  <i className="ri-rocket-line"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Career Advancement</h4>
                  <p className="text-gray-600">Clear pathways for promotion and leadership development across our diverse portfolio of authority domains.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Happy%20diverse%20business%20team%20celebrating%20success%20in%20a%20modern%20office%20environment%2C%20showing%20positive%20workplace%20culture%2C%20team%20bonding%2C%20and%20professional%20achievement%20representing%20company%20culture%20and%20employee%20satisfaction&width=600&height=500&seq=culture-team&orientation=portrait"
              alt="Team Culture"
              className="rounded-xl shadow-lg w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
